// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xO8N6","colBig":"styles_colBig__2lIiu","colSmall":"styles_colSmall__11hYM"};